export default function searchBox() {
  $('.js-search-btn').on('click', function() {
    $('.js-search').addClass("is-search");
  });

  $(document).on('mousedown',function(e) {
     var target = $(e.target);
     if(target.hasClass('search-wrap')){
        $('.js-search').removeClass("is-search");
     }
  });

}


// WEBPACK FOOTER //
// ./js/module/search.js